let internalTrackingHandler;
class Tracking {
    setHandler(trackingHandler) {
        internalTrackingHandler = trackingHandler;
    }

    pushEvent(event, data) {
        if (internalTrackingHandler && typeof internalTrackingHandler.pushEvent === 'function') {
            internalTrackingHandler.pushEvent(event, data);
        } else {
            console.log('no valid tracking handler defined');
        }
    }
}

const tracking = new Tracking();

export default tracking;
